import Cookies from 'js-cookie';

const STORAGE_KEY = 'checkout_preferred_register';
const LEGACY_COOKIE_KEY = 'register';

export function isRegisterUnset(register) {
	return register === '' || register === undefined || register === null || register === 0;
}

export function getPreferredRegister() {
	try {
		const raw = localStorage.getItem(STORAGE_KEY);
		if (raw == null || raw === '') {
			return readLegacyRegisterCookie();
		}
		const pkey = parseInt(raw, 10);
		return Number.isFinite(pkey) && pkey > 0 ? pkey : null;
	} catch {
		return readLegacyRegisterCookie();
	}
}

function readLegacyRegisterCookie() {
	const cookieReg = Cookies.getJSON(LEGACY_COOKIE_KEY);
	if (cookieReg === undefined || cookieReg === null || cookieReg === '') {
		return null;
	}
	const pkey = parseInt(cookieReg, 10);
	if (!Number.isFinite(pkey) || pkey <= 0) {
		return null;
	}
	setPreferredRegister(pkey);
	return pkey;
}

export function setPreferredRegister(pkey) {
	try {
		if (isRegisterUnset(pkey)) {
			localStorage.removeItem(STORAGE_KEY);
			return;
		}
		localStorage.setItem(STORAGE_KEY, String(pkey));
	} catch {
		// ignore localStorage errors
	}
}

export function persistRegisterSelection(property, value) {
	const propertyName = typeof property === 'string' ? property : property?.name;
	if (propertyName === 'register') {
		setPreferredRegister(value);
	}
}
